<!--
  --
  -- データ要素コンポーネント
  --
  -->
<template>
  <div class="text--primary pt-4">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CTitleRow'
}
</script>
